module.exports = __webpack_public_path__ + "static/media/ftc-min.30a797f0.mp4";